import { DocumentViewer } from '@/components/ui/DocumentViewer';

interface UploadQuoteSupportingDocsProps {
  file: File | null;
  isVisible: boolean;
}

export function UploadQuoteSupportingDocs({ file, isVisible }: UploadQuoteSupportingDocsProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="w-full flex flex-col h-full">
      <h2 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-3">
        Source Document
      </h2>
      <div className="bg-card border border-border rounded-lg overflow-hidden flex flex-col min-h-[500px]">
        <DocumentViewer file={file} className="flex-1 min-h-[450px]" />
      </div>
    </div>
  );
}
